import { Logger } from 'simple-logging-lib';
import { apiClientWithMiddleware } from '../../../utils/API';
import { UNIFIED_NAVIGATION_UI_LOGGER_NAME } from '../../../constants/logging';
import { DataFetchingError } from '../../../errors/DataFetchingError';
export const fetchSandboxHubsSelfData = async portalId => {
  try {
    const sandboxSelfData = await apiClientWithMiddleware().get(`/sandbox-hubs/v1/self/?portalId=${portalId}`);
    return sandboxSelfData;
  } catch (e) {
    const cause = e;
    const error = new DataFetchingError('Failed to fetch sandbox self data from API', {
      statusCode: cause.status,
      cause
    });
    const logger = Logger.getLogger(UNIFIED_NAVIGATION_UI_LOGGER_NAME);
    logger.error(error);
    return null;
  }
};